import React, { useState } from 'react';
import { Paper, Stacker, Styler, TemperatureChart, TemperatureChartMonth, TypographyBody, TypographyHero, } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
const monthsName = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
const today = new Date();
export function Weather({ weatherData }) {
    const [activeMonthIndex, setActiveMonthIndex] = useState(today.getMonth());
    const handleMonthChange = (_, monthIndex) => {
        setActiveMonthIndex(monthIndex);
    };
    const { location, months, sectionHeader, sectionSubHeader } = weatherData;
    const { resourceStrings: { HC_MIN_MAX_LABEL, HC_ANNUAL_TEMP, HC_AVERAGE, HC_MIN, HC_MAX }, } = useGlobalContext();
    return (React.createElement(Paper, { py: 10, px: 6, h: "100%" },
        React.createElement(Stacker, { alignItems: "center", spacing: 3, mb: 6, ta: "center" },
            React.createElement(TypographyHero, { color: "text.heading", size: "l" }, sectionHeader),
            sectionSubHeader && React.createElement(TypographyBody, null, sectionSubHeader)),
        React.createElement(Styler, { display: "flex", flexDirection: "column", alignItems: "center" },
            React.createElement(TemperatureChart, { activeMonthIndex: activeMonthIndex, description: `${HC_MIN_MAX_LABEL} ${location}`, onChange: handleMonthChange, title: `${HC_ANNUAL_TEMP} ${location}`, temperatureLabels: { min: HC_MIN, max: HC_MAX, average: HC_AVERAGE } }, months.map(({ month, temperature, minTemperature, maxTemperature }) => {
                return (React.createElement(TemperatureChartMonth, { key: month.toString(), temperatures: {
                        min: parseInt(minTemperature.toFixed(0)),
                        max: parseInt(maxTemperature.toFixed(0)),
                        avg: parseInt(temperature.toFixed(0)),
                    }, monthName: monthsName[month - 1] || '' }));
            })))));
}
